var _defs, _path, _circle, _path2, _path3, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalU98(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.35 51.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f2f3f7;opacity:.76;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.9,32.18h-10.84l7.89-22.93c.11-.32-.06-.67-.38-.78-.32-.11-.67.06-.78.38l-7.96,23.13c-.02.07-.03.13-.03.2h-25.26c0-.07,0-.13-.03-.2l-7.96-23.13c-.11-.32-.46-.49-.78-.38-.32.11-.49.46-.38.78l7.89,22.93H4.45c-2.45,0-4.45,2-4.45,4.45v7.71c0,2.45,2,4.45,4.45,4.45h1.62c-.08.18-.13.37-.13.58v.71c0,.76.62,1.39,1.39,1.39h9.23c.76,0,1.39-.62,1.39-1.39v-.71c0-.21-.05-.4-.13-.58h22.71c-.08.18-.13.37-.13.58v.71c0,.76.62,1.39,1.39,1.39h9.23c.76,0,1.39-.62,1.39-1.39v-.71c0-.21-.05-.4-.13-.58h1.62c2.45,0,4.45-2,4.45-4.45v-7.71c0-2.45-2-4.45-4.45-4.45Zm3.23,12.16c0,1.78-1.45,3.23-3.23,3.23H4.45c-1.78,0-3.23-1.45-3.23-3.23v-7.71c0-1.78,1.45-3.23,3.23-3.23h49.45c1.78,0,3.23,1.45,3.23,3.23v7.71Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.32,
    cy: 40.7,
    r: 2.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.46,38.34c-1.3,0-2.36,1.06-2.36,2.36s1.06,2.36,2.36,2.36,2.36-1.06,2.36-2.36-1.06-2.36-2.36-2.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.03,38.34c-1.3,0-2.36,1.06-2.36,2.36s1.06,2.36,2.36,2.36,2.36-1.06,2.36-2.36-1.06-2.36-2.36-2.36Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.88,
    cy: 40.7,
    r: 2.36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5zG1LP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.13,15.19c-.49.06-.95.19-1.36.49-1.14.82-1.36,2.62-.14,3.67.7.61,1.52.74,2.39.42.86-.32,1.36-.97,1.5-1.87.2-1.24-.69-2.55-2.14-2.69-.07,0-.15-.02-.22-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.2,12.6c.69.02,1.36.12,2,.39.36.15.7.33,1.04.54.83.52,1.6.1,1.89-.57.21-.48.06-1.15-.46-1.51-1.06-.73-2.23-1.17-3.5-1.32-2-.24-3.83.22-5.49,1.33-.55.37-.69,1.11-.37,1.65.32.54.94.85,1.64.51.43-.21.83-.49,1.28-.66.54-.2,1.08-.34,1.65-.34.1,0,.2-.02.3-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.53,5.04c-.42.08-.84.08-1.26.14-.84.12-1.67.31-2.46.6-1.36.49-2.61,1.19-3.75,2.08-.42.33-.59.76-.51,1.26.08.47.37.8.83.96.43.16.83.08,1.18-.2,1.05-.82,2.2-1.46,3.48-1.85.78-.24,1.58-.38,2.39-.45,1.44-.12,2.83.09,4.19.55,1.16.39,2.2.99,3.16,1.75.73.58,1.82.18,1.99-.71.1-.53-.05-.96-.49-1.31-1.28-1.01-2.69-1.76-4.24-2.24-.77-.24-1.56-.4-2.37-.5-.71-.08-1.41-.09-2.12-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.09,0c-.55.08-1.1.11-1.65.19-1.75.28-3.43.78-5.03,1.55-1.47.7-2.82,1.57-4.04,2.65-.43.38-.55,1.04-.3,1.5.27.5.89.77,1.45.64.32-.07.55-.3.79-.5,1.65-1.37,3.52-2.34,5.57-2.93.85-.24,1.71-.4,2.59-.51.83-.1,1.66-.11,2.49-.08.71.03,1.42.12,2.12.26,2.11.4,4.04,1.2,5.82,2.4.48.32.95.67,1.38,1.06.38.33.82.42,1.28.26.46-.16.76-.51.83-1,.08-.55-.19-.97-.61-1.31-.87-.7-1.78-1.35-2.76-1.9-1.31-.72-2.69-1.29-4.14-1.68-1-.27-2.01-.44-3.03-.56-.91-.1-1.82-.05-2.74-.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalU98);
export default __webpack_public_path__ + "static/media/normal_u98.ea957d200d8f87faa2e4cd004449d04b.svg";
export { ForwardRef as ReactComponent };